export default __webpack_public_path__ + "static/media/phoneMarket.7882faff.png";